import React from 'react';

export default function BrandMark({ size = 40, className = '' }) {
  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src="/brand-icon.png?v=2"
      width={size}
      height={size}
      alt="IšgerkVaistus ženklas"
    />
  );
}
